import React, { Component } from 'react'
import { FormControl, FormHelperText } from 'material-ui/Form'
import Input, { InputLabel } from 'material-ui/Input'
import PropTypes from 'prop-types'
import withStyles from 'material-ui/styles/withStyles'

const PROP_TYPES = {
  classes: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  helperText: PropTypes.string,
  input: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  meta: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
}

const styles = theme => ({
  fieldContainer: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column"
  },
})

class FormTextField extends Component {
  render() {
    const {
      classes,
      disabled,
      helperText,
      input,
      label,
      meta: {
        touched,
        error
      },
      type,
    } = this.props

    return (
      <div className={classes.fieldContainer}>
        <div className="form-field">
          <FormControl fullWidth={true} error={touched && error} disabled={disabled}>
            <InputLabel htmlFor={input.name}>{label}</InputLabel>
            <Input
              id={input.name}
              className="input-field"
              {...input}
              type={type} />
            <FormHelperText>{touched && error ? error : helperText}</FormHelperText>
          </FormControl>
        </div>
      </div>
    )
  }
}

FormTextField.propTypes = PROP_TYPES

export default withStyles(styles)(FormTextField)